/**
 * Resultados de um fluxo — uma linha por conversa, com as respostas. São
 * dados pessoais: só quem tem `centuria.fluxos` vê, e a exportação sai
 * direto para o arquivo, sem passar por outro lugar.
 */
import type { BadgeTone } from '@/core/ui';
import type { SessionStatus } from './types';

/** Os mesmos rótulos da planilha (`presentation/export.py`). */
export const SESSION_STATUSES: { value: SessionStatus; label: string; tone: BadgeTone }[] = [
  { value: 'active', label: 'Em andamento', tone: 'neutral' },
  { value: 'completed', label: 'Concluído', tone: 'success' },
  { value: 'handed_off', label: 'Passou para a IA', tone: 'brand' },
  { value: 'failed', label: 'Erro no fluxo', tone: 'danger' },
  { value: 'abandoned', label: 'Abandonado', tone: 'warning' },
];

const BY_VALUE = new Map(SESSION_STATUSES.map((s) => [s.value, s]));

export function sessionStatus(value: string): { label: string; tone: BadgeTone } {
  return BY_VALUE.get(value as SessionStatus) ?? { label: value, tone: 'neutral' };
}

export const RESULTS_PAGE_SIZE = 25;

/**
 * O nome do arquivo do `Content-Disposition` (`attachment; filename="x.csv"`
 * ou `filename*=UTF-8''x.csv`); sem cabeçalho legível, o `fallback`.
 */
export function filenameFromDisposition(header: string | null | undefined, fallback: string): string {
  if (!header) return fallback;
  const star = /filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[1]!.trim().replace(/^"|"$/g, ''));
    } catch {
      /* cai no filename comum */
    }
  }
  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(header);
  return plain ? plain[1]!.trim() : fallback;
}
